<template>
	<div :class="'switch' + (value.includes(name) ? ' active' : '')" @click="click">
		<div class="switch__switch"></div>
	</div>
</template>

<script>
	export default {
		props: {
			value: Array,
			name: String
		},
		methods: {
			click(e) {
				var self = this;
				var value = Array.from(this.value);

				if (value.indexOf(this.name) > -1) {
					value = value.filter(function (item) {
						return item != self.name;
					});
				} else {
					value.push(this.name);
				}

				this.$emit('input', value);
			}
		}
	}
</script>

<style lang="scss">
	.switch {
		width: 40px;
		height: 20px;
		border-radius: 10px;
		background-color: #3b3d44;
		position: relative;
		cursor: pointer;

		&__switch {
			position: absolute;
			left: 2px;
			top: 2px;
			width: 16px;
			height: 16px;
			background-color: black;
			border-radius: 50%;
		}
	}

	.switch.active {
		background-color: #f7223f;

		& > .switch__switch {
			left: auto;
			right: 2px;
		}
	}
</style>